// ProductList2.js (updated - responsive mobile support)
import React, { useState, useEffect, useRef } from "react";
import { FiPlus } from "react-icons/fi";
import { HiOutlineMinus } from "react-icons/hi";
import { FaStar } from "react-icons/fa";
import { PiHeartStraightLight, PiHeartStraightFill } from "react-icons/pi";
import { LuIndianRupee } from "react-icons/lu";
import { BsChevronLeft, BsChevronRight } from "react-icons/bs";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { addToWishlist, removeFromWishlist, getWishlistProducts } from "../../utils/wishlistUtils";
import { Range } from "react-range";
import { TbGridDots } from "react-icons/tb";
import Login from "../Layout/Login/Login";

export default function ProductList2({
  data,
  totalItems,
  subcategoryName,
  isReset,
  fetchNextPage,
  hasMore,
  isFetching,
  onResetFilters,
}) {
  const [showMore, setShowMore] = useState(false);
  const [priceRange, setPriceRange] = useState([0, 100000]);
  const [selectedPriceRange, setSelectedPriceRange] = useState([0, 100000]);
  const [isPriceDropdownOpen, setIsPriceDropdownOpen] = useState(false);
  const [favorites, setFavorites] = useState({});
  const [productsPerRow, setProductsPerRow] = useState(4);
  const [filterMenus, setFilterMenus] = useState([]);
  const [fashionItems, setFashionItems] = useState([]);
  const [currentImageIndex, setCurrentImageIndex] = useState([]);
  const [productImageAnimation, setProductImageAnimation] =
    useState("On Arrow Click ");
  const navigate = useNavigate();
  const [heightRange, setHeightRange] = useState([0, 100]); // example values
  const [selectedHeightRange, setSelectedHeightRange] = useState([0, 100]);

  const [widthRange, setWidthRange] = useState([0, 100]);
  const [selectedWidthRange, setSelectedWidthRange] = useState([0, 100]);

  const [depthRange, setDepthRange] = useState([0, 100]);
  const [selectedDepthRange, setSelectedDepthRange] = useState([0, 100]);

  const [thicknessRange, setThicknessRange] = useState([0, 100]);
  const [selectedThicknessRange, setSelectedThicknessRange] = useState([
    0, 100,
  ]);
  const [isPriceAdjusted, setIsPriceAdjusted] = useState(false);
  const [isHeightAdjusted, setIsHeightAdjusted] = useState(false);
  const [isWidthAdjusted, setIsWidthAdjusted] = useState(false);
  const [isDepthAdjusted, setIsDepthAdjusted] = useState(false);
  const [isThicknessAdjusted, setIsThicknessAdjusted] = useState(false);
  const rowOptions = [2, 3, 4, 5];
  const [vibratingHearts, setVibratingHearts] = useState({});
  const [isLoginModalOpen, setIsLoginModalOpen] = useState(false);
  const openLoginModal = () => setIsLoginModalOpen(true);
  const closeLoginModal = () => setIsLoginModalOpen(false);
  const [webFont, setWebFont] = useState("");
  const [themeColor, setThemeColor] = useState("");
  const [sortOption, setSortOption] = useState("Most Relevant");
  const [showFilter, setShowFilter] = useState(false);
  const [openSort, setOpenSort] = useState(false);
  const [mainCategoryId, setMainCategoryId] = useState("");
  const [subCategoryId, setSubCategoryId] = useState("");
  const [newArrivalChecked, setNewArrivalChecked] = useState(false);




  useEffect(() => {
    if (fashionItems.length === 0) return; // Skip if no items

    const sortedItems = [...fashionItems]; // Create a copy to avoid mutating state

    switch (sortOption) {
      case "Price:Low-High":
        sortedItems.sort((a, b) => a.price - b.price);
        break;

      case "Price:High-Low":
        sortedItems.sort((a, b) => b.price - a.price);
        break;

      case "Alphabetic":
        sortedItems.sort((a, b) => a.title.localeCompare(b.title));
        break;

      case "MostPopular":
        sortedItems.sort((a, b) => b.rating - a.rating);
        break;

      case "Discount:High-Low":
        sortedItems.sort((a, b) => (b.discount || 0) - (a.discount || 0));
        break;

      case "MostRelevant":
        // No sorting needed, keep original order
        break;

      default:
        break;
    }

    setFashionItems(sortedItems); // Update state with sorted items
  }, [sortOption]);

  const syncWishlist = async (items) => {
    const token = sessionStorage.getItem("accessToken");
    if (!token || !Array.isArray(items) || items.length === 0) return;

    try {
      const wishlist = await getWishlistProducts();

      const wishlistSet = new Set(
        wishlist.map((w) => String(w.product_auto_id))
      );

      const updatedFavorites = {};
      items.forEach((item) => {
        updatedFavorites[item.id] = wishlistSet.has(
          String(item.product_auto_id)
        );
      });

      setFavorites(updatedFavorites);
    } catch (err) {
      console.error("Wishlist sync failed:", err);
    }
  };

  useEffect(() => {
    if (fashionItems.length > 0) {
      syncWishlist(fashionItems);
    }
  }, [fashionItems]);

  useEffect(() => {
    const storedStyle = sessionStorage.getItem("UIStyle");
    if (storedStyle) {
      const parsedStyle = JSON.parse(storedStyle);
      setWebFont(parsedStyle.web_font);
      setThemeColor(parsedStyle.web_theme_colour);
    }
  }, []);

  function lightenHexColor(hex, percent) {
    const num = parseInt(hex.replace("#", ""), 16);
    let r = (num >> 16) + 255 * percent;
    let g = ((num >> 8) & 0x00ff) + 255 * percent;
    let b = (num & 0x0000ff) + 255 * percent;

    r = Math.max(0, Math.min(255, Math.round(r)));
    g = Math.max(0, Math.min(255, Math.round(g)));
    b = Math.max(0, Math.min(255, Math.round(b)));

    return `rgb(${r}, ${g}, ${b})`;
  }

  function darkenHexColor(hex, percent) {
    const num = parseInt(hex.replace("#", ""), 16);
    let r = (num >> 16) - 255 * percent;
    let g = ((num >> 8) & 0x00ff) - 255 * percent;
    let b = (num & 0x0000ff) - 255 * percent;

    r = Math.max(0, Math.min(255, Math.round(r)));
    g = Math.max(0, Math.min(255, Math.round(g)));
    b = Math.max(0, Math.min(255, Math.round(b)));

    return `rgb(${r}, ${g}, ${b})`;
  }

  const handleChangeRowProductsPerRow = () => {
    setProductsPerRow((prevRow) => {
      const currentIndex = rowOptions.indexOf(prevRow);
      const nextIndex = (currentIndex + 1) % rowOptions.length; // Cycle through options
      return rowOptions[nextIndex];
    });
  };

  const mapDataToFashionItems = (data1) => {
    const baseUrl =
      "https://grobizapp-n.s3.ap-south-1.amazonaws.com/products_images/";

    return data1.map((product, index) => ({
      id: index + 1,
      product_auto_id: product.product_auto_id,
      title: product.product_name || "Unknown Product",
      price: parseFloat(product.final_product_price) || 0,
      rating: product.avg_rating || 0,
      image:
        product.product_images?.map(
          (img) => `${baseUrl}${img.product_image}`
        ) || [],
      colors: product.color_code ? [product.color_code] : [],
      discount: product.offer_percentage ? parseFloat(product.offer_percentage) : 0,
    }));
  };

  useEffect(() => {
    if (Array.isArray(data) && data.length > 0) {

      // Capture category context ONCE
      setMainCategoryId(data[0]?.main_category_auto_id || "");
      setSubCategoryId(data[0]?.sub_category_auto_id || "");

      const mappedFashionItems = mapDataToFashionItems(data);
      let updatedItems;
      if (isReset) {
        updatedItems = mappedFashionItems;
      } else {
        const existingIds = new Set(fashionItems.map((p) => p.product_auto_id));
        updatedItems = [
          ...fashionItems,
          ...mappedFashionItems.filter((p) => !existingIds.has(p.product_auto_id)),
        ];
      }

      setFashionItems(updatedItems);
      setCurrentImageIndex(new Array(updatedItems.length).fill(0));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  useEffect(() => {
    const handleScroll = () => {
      if (
        window.innerHeight + window.scrollY >= document.body.offsetHeight - 1500 &&
        !isFetching &&
        hasMore
      ) {
        fetchNextPage(); // ← This comes from props
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [fetchNextPage, isFetching, hasMore]);

  useEffect(() => {
    const fetchFilters = async () => {
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_API_BASE_URL}/get_filter_menu`,
          {
            admin_auto_id: sessionStorage.getItem("admin_auto_id"),
          }
        );

        if (response.data.status === 1) {
          const data2 = response.data;

          // Set price range
          const priceList = data2.price_list;
          if (priceList?.length > 0) {
            const min = Number(priceList[0].min_price);
            const max = Number(priceList[0].max_price);
            setPriceRange([min, max]);
            setSelectedPriceRange([min, max]);
          }

          const processedMenus = data2.allfiltermenus.map((menu) => {
            let options = [];
            let type = "select";

            switch (menu.filter_menu_name) {
              case "Price":
                type = "slider";
                break;
              case "Manufacturers":
                options =
                  data2.manufacturer_list?.map((item) => ({
                    label: item.manufacturer_name,
                    value: item._id,
                  })) || [];
                break;
              case "Size":
                options =
                  data2.size_list?.map((item) => ({
                    label: item.size,
                    value: item.size_auto_id,
                  })) || [];
                break;
              case "Brand":
                options =
                  data2.brand_list?.map((item) => ({
                    label: item.brand_name,
                    value: item.brand_auto_id,
                  })) || [];
                break;
              case "Color":
                options =
                  data2.color_list?.map((item) => ({
                    label: item.color_name,
                    value: item._id,
                  })) || [];
                break;
              case "Material":
                options =
                  data2.material_list?.map((item) => ({
                    label: item.material_name,
                    value: item._id,
                  })) || [];
                break;
              case "Discount":
                options =
                  data2.discount_list?.map((item) => ({
                    label: `${item.discount_percent}%`,
                    value: item._id,
                  })) || [];
                break;
              case "Firmness":
                options =
                  data2.firmness_list?.map((item) => ({
                    label: item.unit,
                    value: item._id,
                  })) || [];
                break;
              case "Out of stock":
                options = [{ label: "Include out of stock", value: true }];
                break;
              case "Moq":
                options = Array.from({ length: 10 }, (_, i) => ({
                  label: (i + 1).toString(),
                  value: i + 1,
                }));
                break;
              case "Thickness":
                type = "slider";
                break;

              default:
                options = [];
            }

            return {
              name: menu.filter_menu_name,
              type,
              options,
            };
          });

          // Add additional sliders for dimensions
          const additionalMenus = [
            { name: "Height", type: "slider", options: [] },
            { name: "Width", type: "slider", options: [] },
            { name: "Depth", type: "slider", options: [] },
          ];

          setFilterMenus([...processedMenus, ...additionalMenus]);
        } else {
          console.error("Failed to fetch filter menus");
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchFilters();
  }, []);

  const columnsPerRow = 6;
  const visibleFilters = showMore
    ? columnsPerRow - 2
    : Math.min(columnsPerRow - 2, filterMenus.length);

  const handleNext = (index) => {
    setCurrentImageIndex((prevIndexes) =>
      prevIndexes.map((value, i) =>
        i === index
          ? value === fashionItems[i].image.length - 1
            ? 0
            : value + 1
          : value
      )
    );
  };

  const handlePrevious = (index) => {
    setCurrentImageIndex((prevIndexes) =>
      prevIndexes.map((value, i) =>
        i === index
          ? value === 0
            ? fashionItems[i].image.length - 1
            : value - 1
          : value
      )
    );
  };

  useEffect(() => {
    const storedStyle = sessionStorage.getItem("UIStyle");
    if (storedStyle) {
      const parsedStyle = JSON.parse(storedStyle);

      setProductsPerRow(parseInt(parsedStyle.product_per_row));
      setProductImageAnimation(parsedStyle.product_image_animation);
    }
  }, []);

  useEffect(() => {
    if (productImageAnimation === "Auto Scrolling") {
      const interval = setInterval(() => {
        setCurrentImageIndex((prevIndexes) =>
          prevIndexes.map((value, i) => {
            const item = fashionItems[i];
            const imageCount = item?.image?.length || 0;

            if (imageCount === 0) return 0;

            return value >= imageCount - 1 ? 0 : value + 1;
          })
        );
      }, 3000);

      return () => clearInterval(interval); // Cleanup on unmount
    }
  }, [productImageAnimation, fashionItems]);

  const timersRef = useRef({});
  const startAutoScroll = (index) => {
    stopAutoScroll(index); // Ensure any existing interval is cleared

    timersRef.current[index] = setInterval(() => {
      setCurrentImageIndex((prevIndexes) => {
        const newIndexes = [...prevIndexes];
        newIndexes[index] =
          newIndexes[index] === (fashionItems[index]?.image?.length || 1) - 1
            ? 0
            : newIndexes[index] + 1;
        return newIndexes;
      });
    }, 1000); // Change image every second while hovering
  };

  const stopAutoScroll = (index) => {
    if (timersRef.current[index]) {
      clearInterval(timersRef.current[index]);
      delete timersRef.current[index]; // Remove reference after clearing
    }
  };

  // Toggle heart color on click
  const toggleFavorite = async (id, productId) => {
    const customerId = sessionStorage.getItem("accessToken");
    if (!customerId) {
      // Trigger vibration on the heart icon
      setVibratingHearts((prev) => ({ ...prev, [id]: true }));
      setTimeout(() => {
        setVibratingHearts((prev) => ({ ...prev, [id]: false }));
        openLoginModal(); // Open login modal after vibration
      }, 500); // Vibration duration
      return;
    }

    const isNowFavorite = !favorites[id];
    setFavorites((prev) => ({
      ...prev,
      [id]: isNowFavorite,
    }));
    try {
      if (isNowFavorite) {
        await addToWishlist(productId);
      } else {
        await removeFromWishlist(productId);
      }
    } catch (error) {
      console.error("Error toggling wishlist:", error);
      setFavorites((prev) => ({ ...prev, [id]: !isNowFavorite }));
      setVibratingHearts((prev) => ({ ...prev, [id]: true }));
      setTimeout(() => {
        setVibratingHearts((prev) => ({ ...prev, [id]: false }));
      }, 500);
    }
  };

  const applyFilters = async () => {
    const admin_auto_id = sessionStorage.getItem("admin_auto_id");
    const app_type_id = sessionStorage.getItem("app_type_id");
    const user_auto_id =
      sessionStorage.getItem("accessToken") ||
      sessionStorage.getItem("admin_auto_id");
    const country = localStorage.getItem("country_name") || "India";

    const formData = new FormData();
    formData.append("admin_auto_id", admin_auto_id);
    formData.append("app_type_id", app_type_id);
    formData.append("customer_auto_id", user_auto_id);
    formData.append("country", country);
    formData.append("limit", 10);
    formData.append("page_number", 1);
    formData.append("main_category_id", mainCategoryId);
    formData.append("sub_category_id", subCategoryId);
    if (newArrivalChecked) {
      formData.append("new_arrival", 1);
    }

    // Process <select> filters
    const selects = document.querySelectorAll("select");
    selects.forEach((select) => {
      const key =
        select.getAttribute("data-name") ||
        select.options[0]?.textContent?.trim();
      const value = select.value;
      const label = select.options[select.selectedIndex]?.textContent?.trim();

      if (!key || !value) return;

      switch (key) {
        case "Brand":
          formData.append("brand_id", value);
          break;

        case "Size":
          formData.append("size_id", value);
          break;

        case "Manufacturers":
          formData.append("manufacturer_name", label);
          break;

        case "Material":
          formData.append("material_name", label);
          break;

        case "Firmness":
          formData.append("firmness_type", label);
          break;

        case "Color":
          formData.append("color_name", label);
          break;

        case "Out of stock":
          if (value === "true" || value === "1") {
            formData.append("out_of_stock", true);
          }
          break;

        case "Discount":
          formData.append("min_discount", 0);
          formData.append("max_discount", parseInt(label));
          break;

        case "Moq":
          formData.append("moq", label);
          break;

        default:
          break;
      }
    });

    // Range filters
    if (isPriceAdjusted) {
      formData.append("min_price", selectedPriceRange[0]);
      formData.append("max_price", selectedPriceRange[1]);
    }
    if (isHeightAdjusted) {
      formData.append("min_height", selectedHeightRange[0]);
      formData.append("max_height", selectedHeightRange[1]);
    }
    if (isWidthAdjusted) {
      formData.append("min_width", selectedWidthRange[0]);
      formData.append("max_width", selectedWidthRange[1]);
    }
    if (isDepthAdjusted) {
      formData.append("min_depth", selectedDepthRange[0]);
      formData.append("max_depth", selectedDepthRange[1]);
    }
    if (isThicknessAdjusted) {
      formData.append("min_thickness", selectedThicknessRange[0]);
      formData.append("max_thickness", selectedThicknessRange[1]);
    }

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/get_filter_products`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (response.data.status === 1) {
        const data3 = response.data.get_admin_filter_product_lists;
        const baseUrl =
          "https://grobizapp-n.s3.ap-south-1.amazonaws.com/products_images/";

        const mappedFashionItems = data3.map((product, index) => ({
          id: index + 1,
          product_auto_id: product.product_auto_id,
          title: product.product_name || "Unknown Product",
          price: parseFloat(product.final_product_price) || 0,
          rating: product.avg_rating || 0,
          image:
            product.product_images?.map(
              (img) => `${baseUrl}${img.product_image}`
            ) || [],
          colors: product.color_code ? [product.color_code] : ["#000000"],
          discount: product.offer_percentage ? parseFloat(product.offer_percentage) : 0,
        }));

        setFashionItems(mappedFashionItems);
        setCurrentImageIndex(new Array(mappedFashionItems.length).fill(0));
      } else {
        setFashionItems([]);
        setCurrentImageIndex([]);
      }
    } catch (error) {
      console.error("Error applying filters:", error);
    }
  };

  function clearAllFilters() {
    setSelectedPriceRange(priceRange);
    setSelectedHeightRange(heightRange);
    setSelectedWidthRange(widthRange);
    setSelectedDepthRange(depthRange);
    setSelectedThicknessRange(thicknessRange);

    setIsPriceAdjusted(false);
    setIsHeightAdjusted(false);
    setIsWidthAdjusted(false);
    setIsDepthAdjusted(false);
    setIsThicknessAdjusted(false);

    // Reset <select> elements
    const selects = document.querySelectorAll("select[data-name]");
    selects.forEach((select) => {
      // Always reset to empty string or first option
      select.selectedIndex = 0;
      select.value = "";
      select.dispatchEvent(new Event("change", { bubbles: true }));
    });

    setSortOption("MostRelevant");
    setFashionItems([]);
    onResetFilters?.();
  }

  // Helper: determine responsive cols classes based on productsPerRow
  const getGridColsClass = (perRow) => {
    switch (perRow) {
      case 2:
        return "grid-cols-2 sm:grid-cols-2 md:grid-cols-2";
      case 3:
        return "grid-cols-2 sm:grid-cols-3 md:grid-cols-3";
      case 4:
        return "grid-cols-2 sm:grid-cols-3 md:grid-cols-4";
      case 5:
        return "grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5";
      default:
        return "grid-cols-2 sm:grid-cols-3 md:grid-cols-4";
    }
  };

  // Single renderer for product grid (replaces the repeated blocks)
  const renderProductsGrid = () => {
    const colsClass = getGridColsClass(productsPerRow);
    return (
      <div className={`grid ${colsClass} gap-6 p-4 md:p-6`}>
        {fashionItems
          .filter((item) => item?.image && Array.isArray(item.image))
          .map((item, index) => {
            const imageIndex = currentImageIndex[index] || 0;
            return (
              <div key={item.id} className="relative">
                <div
                  className="relative w-full h-64 sm:h-80 md:h-96"
                  onClick={() =>
                    navigate(`/product-detail/${item.product_auto_id}`)
                  }
                >
                  {productImageAnimation === "On Hover Scrolling" && (
                    <img
                      src={item.image?.[imageIndex] || "https://placehold.co/300x400"}
                      alt={item.title}
                      className="object-cover w-full h-full"
                      onMouseEnter={() => startAutoScroll(index)}
                      onMouseLeave={() => stopAutoScroll(index)}
                    />
                  )}

                  {productImageAnimation === "Auto Scrolling" && (
                    <img
                      src={item.image?.[imageIndex] || "https://placehold.co/300x400"}
                      alt={item.title}
                      className="object-cover w-full h-full"
                    />
                  )}

                  {productImageAnimation === "On Arrow Click" && (
                    <>
                      <img
                        src={item.image?.[imageIndex] || "https://placehold.co/300x400"}
                        alt={item.title}
                        className="object-cover w-full h-full cursor-pointer"
                      />
                      <button
                        className="absolute p-2 transform -translate-y-1/2 bg-white rounded-full shadow-md top-1/2 left-3"
                        onClick={(e) => {
                          e.stopPropagation();
                          handlePrevious(index);
                        }}
                      >
                        <BsChevronLeft className="text-xl text-black" />
                      </button>
                      <button
                        className="absolute p-2 transform -translate-y-1/2 bg-white rounded-full shadow-md top-1/2 right-3"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleNext(index);
                        }}
                      >
                        <BsChevronRight className="text-xl text-black" />
                      </button>
                    </>
                  )}

                  <button
                    className={`absolute p-2 bg-white rounded-full shadow-md bottom-3 right-3 ${vibratingHearts[item.id] ? "vibrate" : ""
                      }`}
                    onClick={(e) => {
                      e.stopPropagation();
                      toggleFavorite(item.id, item.product_auto_id);
                    }}
                  >
                    {favorites[item.id] ? (
                      <PiHeartStraightFill className="text-xl text-black" />
                    ) : (
                      <PiHeartStraightLight className="text-xl text-gray-400" />
                    )}
                  </button>
                </div>

                <h3 className="mt-2 mb-0 text-sm truncate">{item.title}</h3>

                <div className="flex items-center justify-start mt-1">
                  <div className="flex items-center">
                    <span className="flex font-semibold text-md">
                      <LuIndianRupee className="p-0 mt-1" />
                      {item.price}
                    </span>
                    <div className="flex items-center ml-1">
                      {[...Array(5)].map((_, i) => (
                        <FaStar
                          key={i}
                          className={`text-sm ${i < Math.round(item.rating) ? "text-black" : "text-gray-300"
                            }`}
                        />
                      ))}
                    </div>
                  </div>
                </div>

                <div className="flex mt-1 space-x-2">
                  {Array.isArray(item.colors) &&
                    item.colors.map((color, idx) => (
                      <span
                        key={idx}
                        className="w-4 h-4 border border-gray-400 rounded-full cursor-pointer"
                        style={{ backgroundColor: color }}
                      />
                    ))}
                </div>
              </div>
            );
          })}
      </div>
    );
  };

  return (
    <div className={`${webFont} max-w-full`}>
      <style>
        {`
          @keyframes vibrate {
            0% { transform: translate(0); }
            20% { transform: translate(-2px, 2px); }
            40% { transform: translate(-2px, -2px); }
            60% { transform: translate(2px, 2px); }
            80% { transform: translate(2px, -2px); }
            100% { transform: translate(0); }
          }
          .vibrate {
            animation: vibrate 0.3s linear;
          }
        `}
      </style>

      {/* Header: product count + sort */}
      <div className="flex flex-col items-start justify-between gap-3 sm:flex-row sm:items-center md:p-3">
        <div className="flex items-center gap-2 p-3 md:p-0">
          <h4>Product Found</h4>
          <h4>
            ({fashionItems.length > 0 ? fashionItems.length : totalItems})
          </h4>

        </div>

        <div className="flex items-center w-full gap-2 py-2 shadow-md md:shadow-none">
          {/* Sort label + select */}
          <div className="absolute right-0 flex items-center flex-1 hidden gap-2 pr-6 md:block">
            <label className="text-black text-bold-500">Sort by:</label>
            <select
              className="flex-1 px-3 py-1 border rounded-full w-60"
              value={sortOption}
              onChange={(e) => setSortOption(e.target.value)}
            >
              <option value="MostRelevant">Most Relevant</option>
              <option value="MostPopular">Most Popular</option>
              <option value="Alphabetic">Alphabetic</option>
              <option value="Price:Low-High">Price: Low-High</option>
              <option value="Price:High-Low">Price: High-Low</option>
              <option value="Discount:High-Low">Discount: High-Low</option>
            </select>
          </div>
          <div className="flex-1 block text-center md:hidden">

            {/* SORT BY (centered) */}
            <div
              className="flex items-center justify-center cursor-pointer"
              onClick={() => setOpenSort(!openSort)}
            >
              <span className="text-lg font-semibold tracking-wide text-black-600">
                SORT BY
              </span>
              <span className="ml-1 text-sm">▼</span>
            </div>

            {/* Selected option (centered) */}
            <div className="mt-0 text-sm text-gray-500">
              {sortOption === "MostRelevant" ? "Most Relevant" :
                sortOption === "MostPopular" ? "Most Popular" :
                  sortOption === "Alphabetic" ? "Alphabetic" :
                    sortOption === "Price:Low-High" ? "Price: Low-High" :
                      sortOption === "Price:High-Low" ? "Price: High-Low" :
                        sortOption === "Discount:High-Low" ? "Discount: High-Low" : ""}
            </div>

            {/* Dropdown (centered options) */}
            {openSort && (
              <div className="p-2 mt-2 text-center bg-white border rounded-lg shadow-md">

                <div
                  className="py-2 font-medium rounded cursor-pointer hover:bg-gray-100"
                  onClick={() => { setSortOption("MostRelevant"); setOpenSort(false); }}
                >
                  Most Relevant
                </div>

                <div
                  className="py-2 font-medium rounded cursor-pointer hover:bg-gray-100"
                  onClick={() => { setSortOption("MostPopular"); setOpenSort(false); }}
                >
                  Most Popular
                </div>

                <div
                  className="py-2 font-medium rounded cursor-pointer hover:bg-gray-100"
                  onClick={() => { setSortOption("Alphabetic"); setOpenSort(false); }}
                >
                  Alphabetic
                </div>

                <div
                  className="py-2 font-medium rounded cursor-pointer hover:bg-gray-100"
                  onClick={() => { setSortOption("Price:Low-High"); setOpenSort(false); }}
                >
                  Price: Low-High
                </div>

                <div
                  className="py-2 font-medium rounded cursor-pointer hover:bg-gray-100"
                  onClick={() => { setSortOption("Price:High-Low"); setOpenSort(false); }}
                >
                  Price: High-Low
                </div>

                <div
                  className="py-2 font-medium rounded cursor-pointer hover:bg-gray-100"
                  onClick={() => { setSortOption("Discount:High-Low"); setOpenSort(false); }}
                >
                  Discount: High-Low
                </div>

              </div>
            )}

          </div>
          {/* Filter button */}
          <button
            onClick={() => setShowFilter(!showFilter)}
            className="flex-1 p-1 text-lg font-semibold tracking-wide text-black-600 md:hidden"
          >
            FILTER
          </button>
        </div>

      </div>

      {/* Filters - desktop (table) hidden on mobile */}
      <div className="px-4">
        <div className="hidden overflow-x-auto md:block">
          <table className="w-full border border-collapse border-gray-300">
            <tbody>
              <tr>
                <td className="p-2 border w-52">
                  <input
                    type="checkbox"
                    className="w-4 h-4"
                    checked={newArrivalChecked}
                    onChange={(e) => setNewArrivalChecked(e.target.checked)}
                  /> New In

                </td>
                {filterMenus.slice(0, visibleFilters).map((menu, index) => (
                  <td key={index} className="relative border group">
                    <div
                      className="absolute top-0 left-0 w-full h-0.5 scale-x-0 transition-transform duration-300 group-hover:scale-x-100"
                      style={{ backgroundColor: themeColor }}
                    />
                    {menu.name !== "Dimension" && (
                      <>
                        {menu.type === "select" ? (
                          <select className="w-full p-4" data-name={menu.name}>
                            <option value="" disabled selected>
                              Select {menu.name}
                            </option>
                            {menu.options?.map((option, idx) => (
                              <option key={idx} value={option.value}>
                                {option.label}
                              </option>
                            ))}
                          </select>
                        ) : menu.type === "slider" ? (
                          <div className="px-2 py-1">
                            <label className="text-sm font-medium">
                              {menu.name}
                            </label>
                            <Range
                              step={1}
                              min={
                                menu.name === "Price"
                                  ? priceRange[0]
                                  : menu.name === "Height"
                                    ? heightRange[0]
                                    : menu.name === "Width"
                                      ? widthRange[0]
                                      : menu.name === "Depth"
                                        ? depthRange[0]
                                        : thicknessRange[0]
                              }
                              max={
                                menu.name === "Price"
                                  ? priceRange[1]
                                  : menu.name === "Height"
                                    ? heightRange[1]
                                    : menu.name === "Width"
                                      ? widthRange[1]
                                      : menu.name === "Depth"
                                        ? depthRange[1]
                                        : thicknessRange[1]
                              }
                              values={
                                menu.name === "Price"
                                  ? selectedPriceRange
                                  : menu.name === "Height"
                                    ? selectedHeightRange
                                    : menu.name === "Width"
                                      ? selectedWidthRange
                                      : menu.name === "Depth"
                                        ? selectedDepthRange
                                        : selectedThicknessRange
                              }
                              onChange={(values) => {
                                if (menu.name === "Price") {
                                  setSelectedPriceRange(values);
                                  setIsPriceAdjusted(true);
                                } else if (menu.name === "Height") {
                                  setSelectedHeightRange(values);
                                  setIsHeightAdjusted(true);
                                } else if (menu.name === "Width") {
                                  setSelectedWidthRange(values);
                                  setIsWidthAdjusted(true);
                                } else if (menu.name === "Depth") {
                                  setSelectedDepthRange(values);
                                  setIsDepthAdjusted(true);
                                } else {
                                  setSelectedThicknessRange(values);
                                  setIsThicknessAdjusted(true);
                                }
                              }}
                              renderTrack={({ props, children }) => (
                                <div
                                  {...props}
                                  className="h-2 my-2 bg-gray-200 rounded-full"
                                  style={{ ...props.style }}
                                >
                                  {children}
                                </div>
                              )}
                              renderThumb={({ props }) => (
                                <div
                                  {...props}
                                  className="w-4 h-4 bg-black rounded-full"
                                />
                              )}
                            />
                            <div className="text-xs text-gray-600 mt-1 w-[100px]">
                              ₹
                              {menu.name === "Price"
                                ? `${selectedPriceRange[0]} - ${selectedPriceRange[1]}`
                                : menu.name === "Height"
                                  ? `${selectedHeightRange[0]} - ${selectedHeightRange[1]}`
                                  : menu.name === "Width"
                                    ? `${selectedWidthRange[0]} - ${selectedWidthRange[1]}`
                                    : menu.name === "Depth"
                                      ? `${selectedDepthRange[0]} - ${selectedDepthRange[1]}`
                                      : `${selectedThicknessRange[0]} - ${selectedThicknessRange[1]}`}
                            </div>
                          </div>
                        ) : (
                          <div className="p-2 text-sm text-gray-500">Unsupported Filter</div>
                        )}
                      </>
                    )}
                  </td>
                ))}
                <td className="flex justify-center p-4 text-center border">
                  <button
                    className="flex items-center justify-center gap-2 font-semibold "
                    style={{ color: themeColor }}
                    onClick={() => setShowMore(!showMore)}
                  >
                    {showMore ? (
                      <>
                        Less <HiOutlineMinus />
                      </>
                    ) : (
                      <>
                        More <FiPlus />
                      </>
                    )}
                  </button>
                </td>
              </tr>

              {showMore && (
                <>
                  {Array.from({
                    length: Math.ceil(
                      (filterMenus.filter((m) => m.name !== "Dimension").length -
                        visibleFilters) / columnsPerRow
                    ),
                  }).map((_, rowIndex) => {
                    const filteredMenus = filterMenus.filter((m) => m.name !== "Dimension");

                    return (
                      <tr key={rowIndex}>
                        {filteredMenus
                          .slice(
                            visibleFilters + rowIndex * columnsPerRow,
                            visibleFilters + (rowIndex + 1) * columnsPerRow
                          )
                          .map((m, i) => (
                            <td key={i} className="relative border group">
                              <div
                                className="absolute top-0 left-0 w-full h-0.5 scale-x-0 transition-transform duration-300 group-hover:scale-x-100"
                                style={{ backgroundColor: themeColor }}
                              />
                              {m.type === "select" ? (
                                <select className="w-full p-4" data-name={m.name}>
                                  <option value="" disabled selected>
                                    Select {m.name}
                                  </option>
                                  {m.options?.map((option, idx) => (
                                    <option key={idx} value={option.value}>
                                      {option.label}
                                    </option>
                                  ))}
                                </select>
                              ) : m.type === "slider" ? (
                                <div className="px-2 py-1 w-80">
                                  <label className="text-sm font-medium">{m.name}</label>
                                  <Range
                                    step={1}
                                    min={
                                      m.name === "Price"
                                        ? priceRange[0]
                                        : m.name === "Height"
                                          ? heightRange[0]
                                          : m.name === "Width"
                                            ? widthRange[0]
                                            : m.name === "Depth"
                                              ? depthRange[0]
                                              : thicknessRange[0]
                                    }
                                    max={
                                      m.name === "Price"
                                        ? priceRange[1]
                                        : m.name === "Height"
                                          ? heightRange[1]
                                          : m.name === "Width"
                                            ? widthRange[1]
                                            : m.name === "Depth"
                                              ? depthRange[1]
                                              : thicknessRange[1]
                                    }
                                    values={
                                      m.name === "Price"
                                        ? selectedPriceRange
                                        : m.name === "Height"
                                          ? selectedHeightRange
                                          : m.name === "Width"
                                            ? selectedWidthRange
                                            : m.name === "Depth"
                                              ? selectedDepthRange
                                              : selectedThicknessRange
                                    }
                                    onChange={(values) => {
                                      if (m.name === "Price") {
                                        setSelectedPriceRange(values);
                                        setIsPriceAdjusted(true);
                                      } else if (m.name === "Height") {
                                        setSelectedHeightRange(values);
                                        setIsHeightAdjusted(true);
                                      } else if (m.name === "Width") {
                                        setSelectedWidthRange(values);
                                        setIsWidthAdjusted(true);
                                      } else if (m.name === "Depth") {
                                        setSelectedDepthRange(values);
                                        setIsDepthAdjusted(true);
                                      } else {
                                        setSelectedThicknessRange(values);
                                        setIsThicknessAdjusted(true);
                                      }
                                    }}
                                    renderTrack={({ props, children }) => (
                                      <div
                                        {...props}
                                        className="h-2 my-4 bg-gray-200 rounded-full"
                                        style={{ ...props.style }}
                                      >
                                        {children}
                                      </div>
                                    )}
                                    renderThumb={({ props }) => (
                                      <div
                                        {...props}
                                        className="w-4 h-4 bg-black rounded-full"
                                      />
                                    )}
                                  />
                                  <div className="text-xs text-gray-600 mt-1 w-[100px]">
                                    ₹
                                    {m.name === "Price"
                                      ? `${selectedPriceRange[0]} - ${selectedPriceRange[1]}`
                                      : m.name === "Height"
                                        ? `${selectedHeightRange[0]} - ${selectedHeightRange[1]}`
                                        : m.name === "Width"
                                          ? `${selectedWidthRange[0]} - ${selectedWidthRange[1]}`
                                          : m.name === "Depth"
                                            ? `${selectedDepthRange[0]} - ${selectedDepthRange[1]}`
                                            : `${selectedThicknessRange[0]} - ${selectedThicknessRange[1]}`}
                                  </div>
                                </div>
                              ) : (
                                <div className="p-2 text-sm text-gray-500">Unsupported Filter</div>
                              )}
                            </td>
                          ))}
                      </tr>
                    );
                  })}
                </>
              )}
            </tbody>
          </table>
        </div>
      </div>

      {/* Mobile-friendly filters (stacked) - visible only on mobile */}
      <div className="px-4 md:hidden">


        {showFilter && (
          <div className="space-y-3">
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-2">
                <input
                  type="checkbox"
                  className="w-4 h-4"
                  checked={newArrivalChecked}
                  onChange={(e) => setNewArrivalChecked(e.target.checked)}
                />
                <span>New In</span>

              </div>
              <button
                className="p-2"
                onClick={() => setShowMore((s) => !s)}
                aria-expanded={showMore}
              >
                {showMore ? "Less" : "More"}
              </button>
            </div>

            {filterMenus
              .slice(0, Math.min(filterMenus.length, 4))
              .map((menu, idx) => (
                <div key={idx} className="p-2 border rounded">
                  {menu.type === "select" ? (
                    <>
                      <label className="text-sm font-medium">{menu.name}</label>
                      <select className="w-full p-2 mt-1 border rounded" data-name={menu.name}>
                        <option value="">Select {menu.name}</option>
                        {menu.options?.map((opt, idxx) => (
                          <option key={idxx} value={opt.value}>{opt.label}</option>
                        ))}
                      </select>
                    </>
                  ) : (
                    <>
                      <label className="text-sm font-medium">{menu.name}</label>

                      <div className="mt-2">
                        <Range
                          step={1}
                          min={menu.name === "Price" ? priceRange[0] : 0}
                          max={menu.name === "Price" ? priceRange[1] : 100}
                          values={menu.name === "Price" ? selectedPriceRange : [0, 100]}
                          onChange={(values) => {
                            if (menu.name === "Price") {
                              setSelectedPriceRange(values);
                              setIsPriceAdjusted(true);
                            }
                          }}
                          renderTrack={({ props, children }) => (
                            <div {...props} className="h-2 bg-gray-200 rounded-full">
                              {children}
                            </div>
                          )}
                          renderThumb={({ props }) => (
                            <div {...props} className="w-4 h-4 bg-black rounded-full" />
                          )}
                        />
                      </div>
                    </>
                  )}
                </div>
              ))}

            <div className="flex gap-2">
              <button
                className="flex-1 p-2 text-white rounded"
                style={{ backgroundColor: themeColor }}
                onClick={applyFilters}
              >
                Apply Filter
              </button>

              <button
                className="flex-1 p-2 border rounded"
                onClick={clearAllFilters}
                style={{ borderColor: themeColor, color: themeColor }}
              >
                Clear Filter
              </button>
            </div>
          </div>
        )}

      </div>

      {/* Controls (grid toggle + buttons) */}
      <div className="flex items-center justify-between hidden m-4 md:block">
        <button onClick={handleChangeRowProductsPerRow} title="Change Grid Layout" className="p-1">
          <TbGridDots size={28} />
        </button>

        <div className="flex gap-2">
          <button
            className="p-2 text-white transition duration-200 rounded"
            onClick={applyFilters}
            style={{ backgroundColor: themeColor }}
            onMouseEnter={(e) => {
              const darkenedColor = darkenHexColor(themeColor, 0.15); // darken by 15%
              e.currentTarget.style.backgroundColor = darkenedColor;
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = themeColor;
            }}
          >
            Apply Filter
          </button>
          <button
            className="p-2 transition duration-200 border rounded"
            onClick={clearAllFilters}
            style={{
              color: themeColor,
              borderColor: themeColor
            }}
            onMouseEnter={(e) => {
              const darkenedColor = darkenHexColor(themeColor, 0.15); // darken by 15%
              e.currentTarget.style.backgroundColor = darkenedColor;
              e.currentTarget.style.color = "#ffffff";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "#ffffff";
              e.currentTarget.style.color = themeColor;
            }}
          >
            Clear Filter
          </button>
        </div>
      </div>

      {/* Products grid (single renderer handles responsiveness) */}
      {Array.isArray(fashionItems) && fashionItems.length > 0 ? (
        renderProductsGrid()
      ) : (
        <div className="flex flex-col items-center justify-center py-20 text-center">
          <img
            src="https://cdn-icons-png.flaticon.com/512/4076/4076549.png"
            alt="No products"
            className="w-32 h-32 mb-4 opacity-70"
          />
          <h2 className="text-lg font-semibold text-gray-700">
            No products available
          </h2>
          <p className="mt-1 text-sm text-gray-500">
            Try adjusting or clearing filters
          </p>
        </div>
      )}


      {isLoginModalOpen && <Login isOpen={isLoginModalOpen} onClose={closeLoginModal} />}
    </div>
  );
}
